import { authFetch } from "@/utils/api";

/**
 * Readiness API of the law-firm workflows (docs/plans/PLAN_legal-service-agents.md, Phase 1).
 *
 * A 403 means the user is not an admin and a 404 an account that is not the
 * session's: both are "nothing to show", not an error.
 */

export const readinessQueryKey = (accountId) => ["agent-skills", "readiness", accountId];

export class ReadinessUnavailableError extends Error {
  constructor(status) {
    super("Recurso não disponível");
    this.status = status;
  }
}

async function parse(res) {
  if (res.status === 404 || res.status === 403) throw new ReadinessUnavailableError(res.status);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Não foi possível verificar a configuração agora.");
  return data;
}

export async function fetchReadiness(accountId) {
  return parse(await authFetch(`/api/internal/agent-skills/${accountId}/readiness`));
}

export async function refreshReadiness(accountId) {
  return parse(
    await authFetch(`/api/internal/agent-skills/${accountId}/readiness/refresh`, {
      method: "POST",
      body: JSON.stringify({}),
    }),
  );
}
